import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../axios/axiosInstance";

// Persistent browser-session ID — resets when tab/window is closed
const getSessionId = () => {
  let id = sessionStorage.getItem("_tracking_sid");
  if (!id) {
    id = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    sessionStorage.setItem("_tracking_sid", id);
  }
  return id;
};

const SESSION_ID = getSessionId();

const usePageTracking = () => {
  const location = useLocation();
  // trackingRef holds the data for the page that is CURRENTLY being viewed
  const trackingRef = useRef(null);

  useEffect(() => {
    // Only track authenticated users
    const token = localStorage.getItem("token");
    if (!token) return;

    const currentPage = location.pathname;
    const prevPage = trackingRef.current?.page || "";

    // Referrer: previous app page (internal) or browser referrer (external on first load)
    const referrer = prevPage || document.referrer || "";

    // Record start of current page
    trackingRef.current = {
      page: currentPage,
      enteredAt: Date.now(),
      referrer,
    };

    // Cleanup fires when user navigates away — send the completed page view
    return () => {
      const { page, enteredAt, referrer: ref } = trackingRef.current;
      const timeSpentSeconds = Math.round((Date.now() - enteredAt) / 1000);

      // Skip bounces under 1 second
      if (timeSpentSeconds < 1) return;

      api.post("/user-activity/pageview", {
        page,
        pageTitle: document.title,
        referrer:  ref,
        timeSpentSeconds,
        enteredAt: new Date(enteredAt).toISOString(),
        sessionId: SESSION_ID,
      }).catch(() => {});
    };
  }, [location.pathname]);
};

export default usePageTracking;
